export default "__VITE_ASSET__CCFxYHtE__"